import { useMutation } from "@tanstack/react-query";
import usePrivateAxios from "@/common/api/usePrivateAxios";
import { AxiosError } from "axios";
import { CompanyEquipmentDisableValidationSchema } from "../schemas/equipmentActions.schema";

interface UseCompanyEquipmentDisableProps {
  equipmentId?: string;
  onSuccess?: () => void;
  onError?: (error: AxiosError) => void;
}

const useCompanyEquipmentDisable = ({ equipmentId, onSuccess, onError }: UseCompanyEquipmentDisableProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation<void, AxiosError, CompanyEquipmentDisableValidationSchema>({
    mutationKey: ['companyEquipmentDisable', equipmentId],
    mutationFn: (data) => privateAxios.put(`/client/equipments/${equipmentId}/disable`, {
      equipment: {
        disable_reason: data.disable_reason,
      },
    }),
    onSuccess,
    onError,
  });
};

export default useCompanyEquipmentDisable;
